export default class GeoSuggest {
  constructor() {}

  checkAddressComponent(option: any, key: string): any {
    return option.address?.component.find((component: any) => component.kind.includes(key))
  }
}
